import { documentConstants } from "../../constants";

const initialState = {
  unviewedCount: {},
  loading: false,
  error: null,
  lastUpdated: null
};

export function viewReducer(state = initialState, action) {
  switch (action.type) {
    case documentConstants.DOCUMENTS_UNVIEWED_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case documentConstants.DOCUMENTS_UNVIEWED_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        unviewedCount: action.response,
        error: null,
        lastUpdated: Date.now()
      };

    case documentConstants.DOCUMENTS_UNVIEWED_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}